var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home Page"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7316,
    transform: "translate(-1237 -117.37)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147238915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -770,
    y: -17.3699,
    width: 838,
    height: 69,
    rx: 34.5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 31"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 15,
    cy: 15,
    r: 13.5,
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 10",
    x1: 25.3117,
    y1: 24.8242,
    x2: 33.6868,
    y2: 33.1996,
    stroke: "black",
    strokeWidth: 3
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -788.1,
    y: -35.4699,
    width: 874.2,
    height: 105.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.1242970e45004c27458de3049488f47d.svg";
export { ForwardRef as ReactComponent };